var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.343,
    height: 19.273,
    viewBox: "0 0 13.343 19.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-pin",
    "data-name": "Icon ionic-ios-pin",
    d: "M14.546,3.375A6.448,6.448,0,0,0,7.875,9.569c0,4.818,6.671,13.079,6.671,13.079s6.671-8.261,6.671-13.079A6.448,6.448,0,0,0,14.546,3.375Zm0,8.844a2.173,2.173,0,1,1,2.173-2.173A2.173,2.173,0,0,1,14.546,12.219Z",
    transform: "translate(-7.875 -3.375)",
    fill: "#f5aa16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.796085a88866f598a218fe859b401acb.svg";
export { ForwardRef as ReactComponent };